module.exports = __webpack_public_path__ + "assets/images/novasports_news.c6a8f3b1cb60e0972770124f3bfe921d.png";